// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__nIIJ-","barcodesTable":"Sidebar_barcodesTable__1mHsJ"};